import { render, staticRenderFns } from "./TitleDescription.vue?vue&type=template&id=5b346ce5&scoped=true&"
import script from "./TitleDescription.vue?vue&type=script&lang=js&"
export * from "./TitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./TitleDescription.vue?vue&type=style&index=0&id=5b346ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b346ce5",
  null
  
)

export default component.exports